import type { Bid } from '@autobid/ui/types/Bid'
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { SEARCH_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useSearchCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'
import { getUsersBids } from '@autobid/ui/utils/car/getUsersBids'

export function useSearchBidDeleted() {
  const { startListen } = useWebSocketStore()
  const { sessionData } = useAutobidAuth()
  const { updateSearchCar } = useUpdateCar()

  const bidDeleted = () => {
    startListen({
      eventName: 'premium.BID_DELETED',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, price } = event.context

        updateSearchCar(carId, (item) => {
          const newBids = getUsersBids(
            item.bids.filter(
              bid => bid.amount !== price && bid.amount !== Infinity,
            ),
          )
          const newHighestBid: Bid | undefined = newBids[0]

          const hasBid
            = !!(sessionData.value?.user?.id
              && newBids.find(el => el.user_id === sessionData.value?.user?.id))

          const isHighestBidder
            = !!(hasBid && newHighestBid?.user_id === sessionData.value?.user?.id)

          return {
            ...item,
            bids: newBids,
            hasBid,
            isHighestBidder,
            price: {
              ...item.price,
              current: newHighestBid?.amount || 0,
            },
          }
        })
      },
    })
  }

  return { bidDeleted }
}
